import { Skeleton, SkeletonText } from '@buffer-mono/popcorn'

import { SettingsRow } from '../../shared/components/SettingsRow'

import type { JSX } from 'react'

const EmailNotificationsSkeleton = (): JSX.Element => {
  return (
    <SettingsRow>
      <SettingsRow.Header>
        <SkeletonText lines={1} width={100} />
        <SkeletonText lines={1} width={400} />
      </SettingsRow.Header>
      <SettingsRow.Control inline>
        <Skeleton height={24} width={44} rounded />
      </SettingsRow.Control>
    </SettingsRow>
  )
}

export default EmailNotificationsSkeleton
